import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'

const useCredentials = () => {
	const [isLoading, setIsLoading] = useState(true)
	const [credentials, setCredentials] = useState()
	useEffect(() => {
		(async () => {
			if(!credentials) {
				const currentCredentials = await Auth.currentCredentials()
				setCredentials(currentCredentials)
				setIsLoading(false)
			}
		})()
	}, [])
	return {
		data: credentials,
		loading: isLoading
	}
}

export default useCredentials
